import { TamDashboardMapNearbyComponent } from './tam-dashboard-map-nearby/tam-dashboard-map-nearby.component';
import { NgModule } from '@angular/core';
import { TamDashboardMapAutocompleteComponent } from './tam-dashboard-map-autocomplete/tam-dashboard-map-autocomplete';
import { TamDashboardMapTripComponent } from './map-trip/map-trip.component';
import { TamDashboardMapComponent } from './tam-dashboard-map/tam-dashboard-map.component';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PopupModule } from '@progress/kendo-angular-popup';
import { WidgetsModule } from '../../../widgets/widgets.module';
import { AgmCoreModule, MapsAPILoader } from 'ng-agm-core-lib';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TamDashboardMapTripAutocompleteComponent } from './map-trip/map-trip-autocomplete/map-trip-autocomplete.component';
import { TamDashboardMapPoiComponent } from './tam-dashboard-map/tam-dashboard-map-poi/tam-dashboard-map-poi.component';
import { DirectionRendererService } from './tam-dashboard-map/direction-renderer.service';

const components = [
    TamDashboardMapNearbyComponent,
    TamDashboardMapAutocompleteComponent,
    TamDashboardMapComponent,
    TamDashboardMapTripComponent,
    TamDashboardMapTripAutocompleteComponent,
    TamDashboardMapPoiComponent
];
@NgModule({
    declarations: [
        ...components,
    ],
    exports: [
        ...components,
    ], imports: [CommonModule,
        AgmCoreModule,
        PopupModule,
        DropDownsModule,
        WidgetsModule], providers: [
            provideHttpClient(withInterceptorsFromDi()),
            DirectionRendererService
        ]
})
export class TamDashboardMapTileModule {
}
